import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "calendar.icon",
  "use": "calendar.icon-usage",
  "viewBox": "-1580 -11179 18 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-1580 -11179 18 20\" id=\"calendar.icon\"><path d=\"M17,10H7v2H17Zm2-7H18V1H16V3H8V1H6V3H5A1.991,1.991,0,0,0,3.01,5L3,19a2,2,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3Zm0,16H5V8H19Zm-5-5H7v2h7Z\" transform=\"translate(-1583 -11180)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/calendar.icon.svg
// module id = UeWC
// module chunks = 13